import PlusCircleOutlineIcon from 'mdi-react/PlusCircleOutlineIcon'
import React from 'react'

import { Button } from '@mui/material'
import { withStyles, WithStyles } from '@mui/styles'

import styles from './AddItemButton.style'

class AddItemButton extends React.PureComponent<AddItemButtonProps & WithStyles<typeof styles>> {
  render() {
    const { classes, label, children, onClick } = this.props
    return (
      <Button aria-label={label} onClick={onClick} className={classes.button}>
        <PlusCircleOutlineIcon className={classes.addIcon} />
        <span className={classes.buttonLabel}>{children}</span>
      </Button>
    )
  }
}

export type AddItemButtonProps = {
  label: string
  children: React.ReactNode
  onClick: () => any
}

export default withStyles(styles)(AddItemButton)
